/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { remoteSessionClientsGet } from "../funcs/remoteSessionClientsGet.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { RemoteSessionClient } from "../models/components/remotesessionclient.js";
import {
  GetRemoteSessionClientRequest,
  GetRemoteSessionClientSecurity,
} from "../models/operations/getremotesessionclient.js";
import { unwrapAsync } from "../types/fp.js";
export type RemoteSessionClientQueryData = RemoteSessionClient;

export function prefetchRemoteSessionClient(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetRemoteSessionClientRequest,
  security?: GetRemoteSessionClientSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildRemoteSessionClientQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildRemoteSessionClientQuery(
  client$: GramCore,
  request: GetRemoteSessionClientRequest,
  security?: GetRemoteSessionClientSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<RemoteSessionClientQueryData>;
} {
  return {
    queryKey: queryKeyRemoteSessionClient({
      id: request.id,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
      gramProject: request.gramProject,
    }),
    queryFn: async function remoteSessionClientQueryFn(
      ctx,
    ): Promise<RemoteSessionClientQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(remoteSessionClientsGet(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyRemoteSessionClient(
  parameters: {
    id: string;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "remoteSessionClients", "get", parameters];
}
